import { render, staticRenderFns } from "./HeroAsideListItem.vue?vue&type=template&id=35af9478&scoped=true&"
import script from "./HeroAsideListItem.vue?vue&type=script&lang=js&"
export * from "./HeroAsideListItem.vue?vue&type=script&lang=js&"
import style0 from "./HeroAsideListItem.vue?vue&type=style&index=0&id=35af9478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af9478",
  null
  
)

export default component.exports